import { render, staticRenderFns } from "./SecondBanner.vue?vue&type=template&id=125e930c&scoped=true"
import script from "./SecondBanner.vue?vue&type=script&lang=js"
export * from "./SecondBanner.vue?vue&type=script&lang=js"
import style0 from "./SecondBanner.vue?vue&type=style&index=0&id=125e930c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125e930c",
  null
  
)

export default component.exports